import { xtndAnimationStyles } from '@repo/tailwind-config';
import { AppRouter } from '@xtnd/web/app/router';
import { QueryClientProvider, ThemeProvider, Toaster } from '@xtnd/web/providers';
import '@xtnd/web/styles/globals.css';

function App() {
  return (
    <QueryClientProvider>
      <ThemeProvider>
        <style>{xtndAnimationStyles}</style>
        <AppRouter />
        <Toaster />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
